module.exports = __webpack_public_path__ + "static/logo-brand-white-75f9cc0e627c854f938f54c8ec120df7.png";